module.exports = __webpack_public_path__ + "media/images/emblems/Windisch-blason-5d45f61539aa12e9bb15db21007d2b51.png";